"use client";

import { BannerSection } from "@/components/sections/BannerSection";
import { GallerySelection } from "./sections/GallerySelection";
import { BreadcrumbHomepage } from "@/components/sections/BreadcrumbHomepage";

export default function GaleriePage() {
  return (
    <>
      <main className="flex min-h-screen max-w-[100vw] flex-col">
        <BannerSection title="Galerie" />
        <BreadcrumbHomepage />
        <GallerySelection />
      </main>
    </>
  );
}
